import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=774fb779&scoped=true&"
import script from "./EmailVerified.vue?vue&type=script&lang=js&"
export * from "./EmailVerified.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerified.vue?vue&type=style&index=0&id=774fb779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fb779",
  null
  
)

export default component.exports